import React from "react";


const LatestProject2 = () => {
  const capsules = [
    { label: "🚀 MVP Launching Soon", color: "#007bff", bg: "rgba(0,123,255,0.08)" },
    { label: "🤝 Client: Mohammed Eleouja & Jirayr Melikyan", color: "#444", bg: "rgba(0,0,0,0.05)" },
    { label: "🔒 Private • Source shared on request", color: "#d63384", bg: "rgba(214,51,132,0.08)" },
  ];

  const sections = [
    {
      title: "✨ What it does",
      description:
        "Tracks current and upcoming flights, saves journeys, provides detailed statistics on past flights, and sends real-time notifications for delays, gate changes, and terminal updates.",
    },
    {
      title: "⚙️ How it works",
      description:
        "Syncs data with a FastAPI (Python) + SQL backend. Ensures smooth navigation, real-time updates, and offline caching for a seamless user experience.",
    },
    {
      title: "🖥️ Tech Stack",
      description:
        "Frontend: SwiftUI + Core Data. Backend: SQL + FastAPI (Python). Focused on performance, reliability, and scalable architecture.",
    },
  ];

  return (
    <section
      style={{
        padding: "100px 20px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-between",
          maxWidth: "1200px",
          margin: "0 auto",
          gap: "60px",
        }}
      >
        {/* Left Side */}
        <div style={{ flex: "1 1 500px", minWidth: "320px" }}>
          <h2
            style={{
              fontSize: "2.5rem",
              fontWeight: "800",
              marginBottom: "24px",
              color: "#2b213b",
              lineHeight: "1.2",
              fontFamily: "Inter",
            }}
          >
            Latest Project •{" "}
            <span style={{ color: "#db2254", fontFamily: "Inter", }}>Flight Tracker (iOS)</span>
          </h2>

          {/* Capsules */}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "12px",
              marginBottom: "28px",
            }}
          >
            {capsules.map((cap, idx) => (
              <span
                key={idx}
                style={{
                  padding: "6px 14px",
                  border: `1px solid ${cap.color}`,
                  borderRadius: "999px",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                  color: cap.color,
                  backgroundColor: cap.bg,
                  whiteSpace: "nowrap",
                }}
              >
                {cap.label}
              </span>
            ))}
          </div>

          {/* Sections */}
          {sections.map((sec, idx) => (
            <div key={idx} style={{ marginBottom: "24px" }}>
              <h3
                style={{
                  fontSize: "1.35rem",
                  fontWeight: "700",
                  marginBottom: "8px",
                  color: "#2b213b",
                }}
              >
                {sec.title}
              </h3>
              <p
                style={{
                  fontSize: "1rem",
                  color: "#555",
                  lineHeight: "1.7",
                  maxWidth: "600px",
                }}
              >
                {sec.description}
              </p>
            </div>
          ))}
        </div>

        {/* Right Side: Mockup */}
        <div
          style={{
            flex: "1 1 350px",
            minWidth: "260px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "280px",
              aspectRatio: "9 / 19.5",
              borderRadius: "40px",
              border: "2px solid #ccc",
              position: "relative",
              boxShadow: "0 12px 32px rgba(0,0,0,0.15)",
              backgroundColor: "#000000ff",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                position: "absolute",
                inset: "8px",
                borderRadius: "30px",
                backgroundColor: "#f0f0f0",
                overflow: "hidden",
              }}
            >
              <video
                src="https://my-video-assests.s3.eu-north-1.amazonaws.com/Untitled33.m4v"
                autoPlay
                loop
                muted
                playsInline
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "inherit",
                }}
              />
            </div>
          </div>
        </div>
      </div>
      
    </section>
  );
};


export default LatestProject2;
